import { useApolloClient } from '@apollo/react-hooks';
import useAuthQuery from '../../hooks/useAuthQuery';
import { AccountCustomer } from '../../__generated__/pge-types';
import { getContactDetails } from '../../queries/account.query';

export function useUpdateInfoApi() {
  const apolloClient = useApolloClient();

  const fetchContactDetails = () => {
    const { data, loading } = useAuthQuery<{
      getAccountInfo: AccountCustomer;
    }>(getContactDetails, {
      variables: {
        params: {},
      },
    });

    const writeCustomerContactCache = (queryData: Partial<AccountCustomer>) => {
      apolloClient.cache.writeQuery({
        query: getContactDetails,
        data: {
          getAccountInfo: {
            ...data?.getAccountInfo,
            ...queryData,
          },
          variables: {
            params: {},
          },
        },
      });
    };

    return {
      customerContactInfo: data?.getAccountInfo || null,
      writeCustomerContactCache,
      loading,
    };
  };

  return {
    fetchContactDetails,
  };
}
